export default "__VITE_ASSET__DokHTPCK__"